import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { Company } from '@features/contacts/models/company';
import { CompanyService } from '@features/contacts/services/company.service';
import { TagService, TagEntityType } from '@features/opportunities/services/tag.service';
import { commandEvent } from '@shared/components/load/command/command.component';

import { CompanyDetailsComponent, Content } from '../company-details.component';

@Component({
  selector: 'spark-contacts-company-new',
  templateUrl: '../company-details.component.html'
})
export class CompanyNewComponent
  extends CompanyDetailsComponent
  implements OnInit
{
  readonly isNewEntity = true;

  get saveLabel(): string {
    return 'Create';
  }

  get title(): string {
    return 'New Company Contact';
  }

  constructor(
    companyService: CompanyService,
    private tagService: TagService
  ) {
    super(companyService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.update$ = commandEvent(this.change$, (delta) =>
      this.companyService.updateCompany(this.companyId, delta).pipe(
        switchMap(() => {
          if (this.pendingTags.length === 0) {
            return of({});
          }
          const requests = this.pendingTags.map(tag => ({ tagId: tag.tagId, tagName: tag.tagName }));
          return this.tagService.addTagsToEntity(
            TagEntityType.Companies, this.companyId, requests
          ).pipe(map(() => ({})));
        })
      )
    );
  }

  content(): Observable<Content> {
    return of({
      company: {} as Company.Model,
      contacts: []
    });
  }
}
